import { Transform } from 'class-transformer';
import { DateFilter } from '../../interfaces/filters/date.filter';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { arrayOrStringToArray } from '../../types-transformers/array-transformers';
import { stringToBooleanNullable } from '../../types-transformers/boolean-transformers';
import { EventAttendanceOptionsEnum, OrderStatusEnum } from '../../enums';

export class OrdersFilter implements PaginationFilter, DateFilter {
	@Transform(arrayOrStringToArray)
	authorIds?: string[];

	@Transform(arrayOrStringToArray)
	paymentIntentIds?: string[];

	search?: string;

	membershipId?: string;
	membershipTierId?: string;

	challengeId?: string;

	blastPlanId?: string;

	eventId?: string;
	eventInstanceDate?: Date;

	periodFrom?: Date;
	periodTo?: Date;

	pageSize?: number | null;
	page?: number | null;

	@Transform(stringToBooleanNullable)
	fullData?: boolean;

	@Transform(stringToBooleanNullable)
	withPayouts?: boolean;

	pageCursor?: string;

	checkedIn?: boolean;

	@Transform(stringToBooleanNullable)
	onlyPaid?: boolean;

	@Transform(arrayOrStringToArray)
	statusIds?: OrderStatusEnum[];

	@Transform(arrayOrStringToArray)
	acceptanceOptionsIds?: EventAttendanceOptionsEnum[];

	@Transform(arrayOrStringToArray)
	eventPriceBaseIds?: string[];

	@Transform(arrayOrStringToArray)
	discountIds?: string[];
}
